import { render } from "./Tributes.vue?vue&type=template&id=d61917b6"
import script from "./Tributes.vue?vue&type=script&lang=js"
export * from "./Tributes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/kingdomIn/Tributes.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d61917b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d61917b6', __exports__)) {
    api.reload('d61917b6', __exports__)
  }
  
  module.hot.accept("./Tributes.vue?vue&type=template&id=d61917b6", () => {
    api.rerender('d61917b6', render)
  })

}


export default __exports__